import { Text, View } from '@react-pdf/renderer';
import { dateFormat } from "helpers/common";

export const ClientDetailsPdf = ({ styles, data, clientType }) => {
  console.log("clientType", clientType);
  console.log("data", data);


  return (
    <>
      <View>
        <Text style={styles.subHeading}>FIRST NAME</Text>
        <Text style={{ ...styles.fontLight, fontSize: 16, marginTop: "2px" }}>{data?.firstname}</Text>
      </View>
      <View>
        <Text style={styles.subHeading}>LAST NAME</Text>
        <Text style={{ fontSize: 16, ...styles.fontLight, marginTop: "2px" }}>{data?.lastname}</Text>
      </View>
      <View style={{ justifyContent: "space-between" }}>
        <Text style={styles.subHeading}>CITY/TOWN</Text>
        <Text style={{ ...styles.para2, ...styles.clientSubInfo }}>{data?.city_town}</Text>
      </View>
      <View style={{ justifyContent: "space-between" }}>
        <Text style={styles.subHeading}>DATE OF BIRTH</Text>
        <Text style={{ ...styles.para2, ...styles.clientSubInfo }}>{data?.dob}</Text>
      </View>
      {/* {!["chatter"].includes(clientType) && (
        <View style={{ justifyContent: "space-between" }}>
          <Text style={styles.subHeading}>GRADE</Text>
          <Text style={{ ...styles.para, ...styles.clientSubInfo }}>{data?.grade}</Text>
        </View>
      )} */}
      <View style={{ justifyContent: "space-between" }}>
        <Text style={styles.subHeading}>GRADE</Text>
        <Text style={{ ...styles.para2, ...styles.clientSubInfo }}>{data?.grade}</Text>
      </View>
      <View style={{ justifyContent: "space-between" }}>
        <Text style={styles.subHeading}>AGE</Text>
        <Text style={{ ...styles.para2, ...styles.clientSubInfo }}>{data?.age}</Text>
      </View>
    </>
  )
}